import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import Layout from "../Layout"
import { FiscaisForm } from "../modais"
class FiscaisEditForm extends Component {
  constructor() {
    super()
    this.onSuccess = this.onSuccess.bind(this)
  }
  onSuccess() {
    this.props.history.push("/fiscais")
  }
  render() {
    return (
      <Layout tabActive="Fiscais de contrato">
        <FiscaisForm isEditing={true} callBackFiscais={this.onSuccess} />
      </Layout>
    )
  }
}
export default withRouter(FiscaisEditForm)



// WEBPACK FOOTER //
// ./src/views/fiscais/FiscaisEditForm.js